<template>
  <li class="item">
    <div class="bold" :class="itemData.active ? 'item-active' : 'item-no-active'">
      <div
        class="mode"
        :style="`padding-left: ${(itemData.level || 0) * 10}px`"
      >
        <Icon
          class="f-caret"
          :class="!itemData.toggleOpen ? 'toRight' : 'toDown'"
          :type="
            itemData.children &&
              itemData.children.length > 0 &&
              'ios-arrow-forward'
          "
          @click="changeToggleOpen"
        ></Icon>
        <span class="item-name" @click="changeActive(itemData)">
          <Tooltip v-showtip placement="top">
            <div slot="content" style="white-space: normal;">
              {{ itemData.title }}
            </div>
            <div
              class="ellipsis"
              :style="`width: ${210 - (itemData.level || 0) * 10}px`"
            >
              <i class="folder"></i>
              <span class="ellipse-text">{{ itemData.title }}</span>
            </div>
          </Tooltip>
        </span>
      </div>
    </div>
    <ul
      v-if="
        itemData.children && itemData.children.length > 0 && itemData.toggleOpen
      "
    >
      <TreeItem
        v-for="item in itemData.children"
        :item-data="item"
        :key="item.id"
        @change-active="changeActive"
      ></TreeItem>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'TreeItem',
  props: {
    itemData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  methods: {
    changeActive(itemData) {
      this.$emit('change-active', itemData);
    },
    changeToggleOpen() {
      this.itemData.toggleOpen = !this.itemData.toggleOpen;
    }
  },
  mounted() {}
};
</script>
<style scoped>
.item {
  cursor: pointer;
}
.item-active {
  background: #2d8cf0;
  color: #fff !important;
  border-radius: 4px;
}
.item .bold {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.item .folder {
  color: #bfbfbf;
  width: 12px !important;
  height: 12px !important;
  margin-right: 5px;
}
.mode {
  display: flex;
  width: 100%;
}
.mode .item-name {
  flex: 1;
  width: calc(100% - 6px);
}
.item .item-no-active:hover {
  background-color: #E2E5EA;
  color: #3E98E9
}
.f-caret {
  margin-right: 12px;
  width: 6px;
  display: inline-block;
  vertical-align: middle;
}
.toDown {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  height: 20px;
}
.toRight {
  /* height: 15px; */
  padding-top: 4px;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
